var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgJira = function SvgJira(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3117 0H8.37329C8.37329 1.91644 9.97931 3.47634 11.9524 3.47634H13.4208V4.83567C13.4208 6.75209 15.0269 8.31203 17 8.31203V0.668527C17 0.289697 16.7018 0 16.3117 0Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3884 3.83301H4.44995C4.44995 5.74945 6.05599 7.30933 8.02915 7.30933H9.4975V8.69097C9.4975 10.6074 11.1036 12.1673 13.0767 12.1673V4.50151C13.0767 4.14498 12.7784 3.83301 12.3884 3.83301Z",
    fill: "url(#paint0_linear_9104_2316)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46508 7.68799H0.526611C0.526611 9.60441 2.13265 11.1643 4.10579 11.1643H5.57418V12.5237C5.57418 14.4401 7.18021 16 9.15333 16V8.35647C9.15333 7.97765 8.83218 7.68799 8.46508 7.68799Z",
    fill: "url(#paint1_linear_9104_2316)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9104_2316",
    x1: 12.9078,
    y1: 3.85224,
    x2: 9.63402,
    y2: 7.32821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9104_2316",
    x1: 9.20511,
    y1: 7.71359,
    x2: 5.41343,
    y2: 11.5119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgJira);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "jira.0428069aabfebe30622a375b17cd86f4.svg";